class MstProductGallery extends HTMLElement {
  connectedCallback() {
    this.main = this.querySelector('[data-gallery-main]');
    this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));

    if (!this.main || this.slides.length === 0) return;

    const initialMediaId = this.slides[0]?.dataset.gallerySlide;
    if (initialMediaId) {
      this.#selectMedia(initialMediaId, this.thumbs[0] ?? null);
    }

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.#selectMedia(thumb.dataset.galleryThumb, thumb));
    });
  }

  #selectMedia(mediaId, thumb) {
    if (!mediaId) return;

    this.slides.forEach((slide) => {
      const isActive = slide.dataset.gallerySlide === mediaId;
      slide.toggleAttribute('hidden', !isActive);
      slide.classList.toggle('is-active', isActive);
    });

    if (!this.thumbs.length) return;

    this.thumbs.forEach((item) => {
      const isActive = thumb ? item === thumb : item.dataset.galleryThumb === mediaId;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });
  }
}

if (!customElements.get('mst-product-gallery')) {
  customElements.define('mst-product-gallery', MstProductGallery);
}
